import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router'

import { useAuthStore } from '@/features/user-login/useAuthStore.ts'
import { Spinner } from '@/shared/ui/spinner.tsx'

const RouteLoadingFallback = () => (
	<div className='flex min-h-[50vh] items-center justify-center'>
		<Spinner className='h-8 w-8' />
	</div>
)

export const PublicRoute = () => {
	const { isAuthenticated, isInitialized } = useAuthStore()

	if (!isInitialized) return null

	if (isAuthenticated) return <Navigate to='/' replace />

	return (
		<Suspense fallback={<RouteLoadingFallback />}>
			<Outlet />
		</Suspense>
	)
}
